import { fetcher } from "helpers/fetcher";

import {
  TUpdateJobListingWorkingHoursReq,
  TUpdateJobListingWorkingHoursRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateJobListingWorkingHours = async (
  payload: TUpdateJobListingWorkingHoursReq
) => {
  return await fetcher<
    TUpdateJobListingWorkingHoursRes,
    TUpdateJobListingWorkingHoursReq["data"]
  >(ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_WORKING_HOURS, {
    data: payload.data,
    headers: {
      [API_HEADER.CORP_ID]: payload.idCorp,
    },
  });
};

export const mutationUpdateJobListingWorkingHours = async (
  payload: TUpdateJobListingWorkingHoursReq
) => {
  return (await updateJobListingWorkingHours(payload)).data;
};

mutationUpdateJobListingWorkingHours._key = (
  payload: TUpdateJobListingWorkingHoursReq
) => [ENDPOINT.CORPORATION.UPDATE_JOB_LISTING_WORKING_HOURS.url, payload];
